// extracted by mini-css-extract-plugin
module.exports = {"Logo":"login_Logo__29mAN","ErrorMsg":"login_ErrorMsg__3-T4D","Icon":"login_Icon__3jW1d","LoginForm":"login_LoginForm__3fvuv","Form":"login_Form__YAl8r"};